import { AvaliacoesModule } from 'app/modules/avaliacoes/avaliacoes.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { OrderModule } from 'ngx-order-pipe';
import { MDBBootstrapModule, ChartsModule } from 'angular-bootstrap-md';
import { NgxFileDropModule } from 'ngx-file-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { DiagnosticoNr1Component } from './components/diagnosticonr1/diagnosticonr1.component';
import { DiagnosticoNr1RoutingModule } from './diagnosticonr1.routing.module';
import { DiagnosticoNr1DetalhesComponent } from './components/diagnosticonr1-detalhes/diagnosticonr1-detalhes.component';
import { DiagnosticoNr1CadastrarComponent } from './components/diagnosticonr1-cadastrar/diagnosticonr1-cadastrar.component';
import { DiagnosticoNr1AtualizarComponent } from './components/diagnosticonr1-atualizar/diagnosticonr1-atualizar.component';
import { DiagnosticoNr1ClonarComponent } from './components/diagnosticonr1-clonar/diagnosticonr1-clonar.component';
import { DiagnosticoNr1SetFatoresComponent } from './components/diagnosticonr1-set-fatores/diagnosticonr1-set-fatores.component';
import { DiagnosticoNr1SearchMotivadoresComponent } from './components/diagnosticonr1-search-motivadores/diagnosticonr1-search-motivadores.component';
import { DiagnosticoNr1SearchComportamentoComponent } from './components/diagnosticonr1-search-comportamento/diagnosticonr1-search-comportamento.component';
import { DiagnosticoNr1SearchAxiologiaComponent } from './components/diagnosticonr1-search-axiologia/diagnosticonr1-search-axiologia.component';
import { DiagnosticoNr1FiltroComponent } from './components/diagnosticonr1-filtro/diagnosticonr1-filtro.component';
import { DiagnosticoNr1DetalhesSelecionarComponent } from './components/diagnosticonr1-detalhes-selecionar/diagnosticonr1-detalhes-selecionar.component';
import { DiagnosticoNr1TreinamentosComponent } from './components/diagnosticonr1-treinamentos/diagnosticonr1-treinamentos.component';
import { DiagnosticoNr1FeedbackComponent } from './components/diagnosticonr1-feedback/diagnosticonr1-feedback.component';
import { DiagnosticoNr1DetalhesExportPDFComponent } from './components/diagnosticonr1-detalhes-export-pdf/diagnosticonr1-detalhes-export-pdf.component';


@NgModule({
  imports: [
    AvaliacoesModule,
    DiagnosticoNr1RoutingModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    OrderModule,
    NgxFileDropModule,
    ChartsModule,
    MDBBootstrapModule.forRoot(),
    DragDropModule,
  ],
  declarations: [
    DiagnosticoNr1Component,
    DiagnosticoNr1DetalhesComponent,
    DiagnosticoNr1CadastrarComponent,
    DiagnosticoNr1AtualizarComponent,
    DiagnosticoNr1ClonarComponent,
    DiagnosticoNr1FiltroComponent,
    DiagnosticoNr1SearchAxiologiaComponent,
    DiagnosticoNr1SearchComportamentoComponent,
    DiagnosticoNr1SearchMotivadoresComponent,
    DiagnosticoNr1SetFatoresComponent,
    DiagnosticoNr1DetalhesSelecionarComponent,
    DiagnosticoNr1TreinamentosComponent,
    DiagnosticoNr1FeedbackComponent,
    DiagnosticoNr1DetalhesExportPDFComponent
  ],
  exports: [
    DiagnosticoNr1FeedbackComponent
  ]
})

export class DiagnosticoNr1Module {}
